import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { ImportOptionsController } from '../controller/ImportOptionsController';
import { Observable } from 'rxjs';
import { AccountsForMdrContactDataProvider } from '../../../../../ui/gzSingleSelectComplex/dataProvider/company/AccountsForMdrContactDataProvider';
import { MdrMandatoryContactInformation } from '../../../../types/company-data';
import { MdrContactImportSource, MdrContactImportSourceValue } from '../../common/types';
import { isEmpty } from 'lodash';
import { ImportOptionsViewData, ImportOptionsLayout } from '../types/ImportOptionsViewData';
import { FormGroup } from '../../../../../ui/gzForm/formGroup/form-group';

export class ImportOptionsWebComponent extends BaseWebComponentElement {
  public controller!: ImportOptionsController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ImportOptionsController,
    });
  }

  public get value(): MdrContactImportSource {
    const selectedValue: MdrContactImportSource = this.controller.view.formGroup
      .value as unknown as MdrContactImportSource;

    selectedValue.importSource = parseInt(selectedValue.importSource as unknown as string, 10);
    return selectedValue;
  }

  public get storedValue(): MdrContactImportSourceValue {
    const formValue = this.controller.view.storedFormGroup.value;

    return {
      ...(formValue.importedCompanyId ? { importedCompanyId: formValue.importedCompanyId } : {}),
      ...(formValue.importedAccountId ? { importedAccountId: formValue.importedAccountId } : {}),
    } as MdrContactImportSourceValue;
  }

  public get formFilled$(): Observable<boolean> {
    return this.controller.formFilled$;
  }

  public getStoredFormGroup(): FormGroup {
    return this.controller.view.storedFormGroup;
  }

  public setStoredFormGroupValue(value: MdrContactImportSourceValue): void {
    this.controller.view.storedFormGroup.value = {
      importedCompanyId: value.importedCompanyId ?? null,
      importedAccountId: value.importedAccountId ?? null,
    };
  }

  public resetForm(): void {
    if (!this.viewData) {
      return;
    }

    const layout = this.controller.getLayout(this.viewData);

    if (layout === ImportOptionsLayout.SELF_ACCOUNT_ONLY) {
      this.controller.view.dom.$accountSelectorFromSelf.value = undefined as unknown as string;
      this.controller.view.dom.$accountSelectorFromSelf.validate();
      this.controller.view.dom.$accountSelectorFromSelf.resetField();
    } else {
      this.controller.view.dom.$radioGroup.value = '';
    }

    this.controller.updateFormFilledSubject();
  }

  public get selectedAccount(): MdrMandatoryContactInformation | null {
    let selectedAccountId: string;
    let repository: AccountsForMdrContactDataProvider;

    if (!this.viewData) {
      return null;
    }

    const layout = this.controller.getLayout(this.viewData);

    if (layout === ImportOptionsLayout.SELF_ACCOUNT_ONLY) {
      selectedAccountId = this.controller.view.dom.$accountSelectorFromSelf.value as string;
      repository = this.controller.view.dom.$accountSelectorFromSelf.Input.controller.dataRepository
        .dataProvider as AccountsForMdrContactDataProvider;
    } else {
      selectedAccountId = this.controller.view.dom.$accountSelector.value as string;
      repository = this.controller.view.dom.$accountSelector.Input.controller.dataRepository
        .dataProvider as AccountsForMdrContactDataProvider;
    }

    if (isEmpty(selectedAccountId)) {
      return null;
    }

    return repository.getCachedAccount(selectedAccountId);
  }

  public get viewData(): ImportOptionsViewData | undefined {
    const attributeValue = this.getAttribute('data-view-data');
    return attributeValue ? JSON.parse(attributeValue) : undefined;
  }

  public set viewData(value: ImportOptionsViewData | undefined) {
    if (typeof value !== 'undefined') {
      this.setAttribute('data-view-data', JSON.stringify(value));
    } else {
      this.removeAttribute('data-view-data');
    }
  }
}
